import script from "./DropdownAd.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownAd.vue?vue&type=script&setup=true&lang=js"

import "./DropdownAd.vue?vue&type=style&index=0&id=be6fb2ec&lang=scss"

const __exports__ = script;

export default __exports__